import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import type { HttpHandler } from 'msw'
import './index.css'
import '@clofo/i18n'
import router from './router'
import { ScenarioDropdown } from '@clofo/ui/scenario-dropdown'
import { logger, scrubRequestInBreadcrumb, scrubRequestInEvent } from '@clofo/lib/logger'
import { oneTrust } from '@clofo/lib/one-trust'
import { http } from '@clofo/data/api'

http.setRedirectOn401(false)

logger.init({
  dsn: 'https://b1739c87be1e185e4c25e25fc7ce61df@o15773.ingest.us.sentry.io/4511831196106752',
  environment: import.meta.env.MODE,
  normalizeDepth: 10,
  enabled: !import.meta.env.DEV,
  beforeSend: scrubRequestInEvent,
  beforeBreadcrumb: scrubRequestInBreadcrumb,
})

oneTrust.init()

async function enableMocking(): Promise<Record<string, HttpHandler[]>> {
  if (!import.meta.env.DEV) return {}

  const { worker } = await import('./mocks/browser')
  await worker.start({
    onUnhandledRequest: 'bypass',
  })

  return (await import('./mocks/scenarios')).scenarios
}

enableMocking().then(scenarios => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <RouterProvider router={router} />
      <ScenarioDropdown scenarios={scenarios} defaultOpen />
    </React.StrictMode>,
  )
})
